export enum TSRadioSizeEnum {
    SMALL = 'small',
    MEDIUM = 'medium',
    LARGE = 'large'
}
export enum TSRadioOrientationEnum {
    VERTICAL = 'vertical',
    HORIZONTAL = 'horizontal'
}
